import React from "react";
import PdfSubHeadingText from "./PdfSubHeadingText";
import _ from "lodash";

const PdfSubheading = ({
  quationno,
  quationDate,
  contact,
  placeofsupply,
  salesperson,
}) => {
  return (
    <div className="pdfsubheading">
      <div className="pdfsubheadingbox">
        <PdfSubHeadingText heading="Quotation No" content={quationno} />
        <PdfSubHeadingText heading="Quotation Date" content={new Date(quationDate).toLocaleDateString("en-GB")} />
        <PdfSubHeadingText heading="Contact" content={contact} />
      </div>
      <div className="pdfsubheadingbox">
        <PdfSubHeadingText heading="Place of Supply" content={placeofsupply} />
        <PdfSubHeadingText heading="Sales person" content={_.upperFirst(salesperson)} />
      </div>
    </div>
  );
};

export default PdfSubheading;
